import { render } from "./NewOrderForm.vue?vue&type=template&id=305bd9c1&ts=true"
import script from "./NewOrderForm.vue?vue&type=script&lang=ts"
export * from "./NewOrderForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__